module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/check-circle-error.f8a750e1.svg";